import React from 'react';
import css from './hoverLine.module.scss';

export const HoverLine: React.FC<{ x?: number; yStart?: number; yEnd?: number }> = ({
  x,
  yStart,
  yEnd,
}) => (
  <line
    data-component="HoverLine"
    className={css.tooltipLine}
    x1={x}
    x2={x}
    y1={yStart}
    y2={yEnd}
    strokeDasharray="5, 1"
    strokeWidth="1"
  />
);
